import { Merchant } from '@frontend/api-payments';
import { contextFactory } from '@frontend/design-system';
import { PublicSwitch } from '../components/switches/public-switch';
import { UseProcessorData } from '../hooks/use-processor-data';
import { ProcessorDataAuthenticatedProvider } from './processor-data/processor-data-authenticated';
import { ProcessorDataPublicProvider } from './processor-data/processor-data-public';

export type ProcessorDataContextValue = UseProcessorData;

export const [ProcessorDataContext, useProcessorDataContext] = contextFactory<ProcessorDataContextValue>(
  '',
  {} as ProcessorDataContextValue
);

export type ProcessorDataProviderProps = React.PropsWithChildren<{
  merchant?: Merchant;
}>;

export const ProcessorDataProvider = ({ children, merchant }: ProcessorDataProviderProps) => {
  return (
    <PublicSwitch
      publicContent={ProcessorDataPublicProvider}
      authenticatedContent={ProcessorDataAuthenticatedProvider}
      propsToBind={{ merchant }}
    >
      {children}
    </PublicSwitch>
  );
};
